
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PoApprovalGroupGrid extends Serenity.EntityGrid<PoApprovalGroupRow, any> {
        protected getColumnsKey() { return PoApprovalGroupColumns.columnsKey; }
        protected getDialogType() { return PoApprovalGroupDialog; }
        protected getIdProperty() { return PoApprovalGroupRow.idProperty; }
        protected getInsertPermission() { return PoApprovalGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return PoApprovalGroupRow.localTextPrefix; }
        protected getService() { return PoApprovalGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}